// extracted by mini-css-extract-plugin
module.exports = {"heading":"Search_heading__2XGKG","searchBox":"Search_searchBox__1glsk","hr":"Search_hr__UBL48","result":"Search_result__Kg9Js","minSearchHeight":"Search_minSearchHeight__yXuRM"};